import { render, staticRenderFns } from "./QuotaAdd.vue?vue&type=template&id=e0e9bfb0&scoped=true"
import script from "./QuotaAdd.vue?vue&type=script&lang=js"
export * from "./QuotaAdd.vue?vue&type=script&lang=js"
import style0 from "./QuotaAdd.vue?vue&type=style&index=0&id=e0e9bfb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e9bfb0",
  null
  
)

export default component.exports